/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 16,
    height: 16,
    viewBox: '0 0 68.53 56.72',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M65.67 46.87a33.88 33.88 0 0 1-5.73 9.41H8.59a33.83 33.83 0 1 1 59.51-22"/><path pid="1" class="cls-2" d="M36.4 29.9l-14.22-8.53 8.53 14.22A4.21 4.21 0 0 0 32.13 37a4.15 4.15 0 1 0 4.27-7.1z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/dashboard.js